import { render, staticRenderFns } from "./SelecionarAcesso.vue?vue&type=template&id=5b677d98"
import script from "./SelecionarAcesso.vue?vue&type=script&lang=ts"
export * from "./SelecionarAcesso.vue?vue&type=script&lang=ts"
import style0 from "./SelecionarAcesso.vue?vue&type=style&index=0&id=5b677d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports